<template>
  <div>
    <SelectStatic title="Conta Bancária" :data="notConnectedAccounts"
      :initialValue="{ id: '', content: '' }" v-model="selectedAccount" />
    <Alert type="info">
      <span>
        Conecte a conta ao Open Finance e tenha <b>Integração Bancária Automática</b>
      </span>
    </Alert>
    <div class="text-right">
      <Button _key="btnConnectOpenFinanceAccount" title="Conectar" classIcon="fa-solid fa-plug"
        backGroundColor="var(--color-brand)" color="var(--text-inverse)" size="medium"
        :disabled="!selectedAccount.id" :clicked="getConnectToken" />
    </div>
  </div>
</template>

<script>
import Button from "@/ui/forms/Button";
import Alert from "@/ui/layout/Alert";
import SelectStatic from "@/ui/forms/SelectStatic";

import BankAccountService from "../../services/bankAccount.service";

import { mapMutations } from "vuex";

export default {
  name: "ConnectOpenFinanceAccount",
  props: ["value"],
  components: {
    Button, Alert, SelectStatic
  },
  data() {
    return {
      notConnectedAccounts: [],
      selectedAccount: { id: "", content: "" },
    };
  },
  created() {
    this.loadNotConnectedAccounts();
  },
  methods: {
    ...mapMutations("generic", ["removeLoading", "hideVodal"]),
    async loadNotConnectedAccounts() {
      const response = await BankAccountService.getAll();
      this.notConnectedAccounts = (response.content.items || [])
        .filter((item) => !item.isPluggyConnected)
        .map((item) => ({ id: item.id, content: item.name }));
    },
    async getConnectToken() {
      const response = await BankAccountService.getConnectToken();
      this.openPluggyConnect(response.content);
    },
    openPluggyConnect(connectToken) {
      this.removeLoading(["btnConnectOpenFinanceAccount"]);
      const pluggyConnect = new window.PluggyConnect({
        connectToken: connectToken,
        includeSandbox: false,
        onSuccess: (itemData) => {
          this.updateBankAccount(itemData.item.id);
        },
        onError: (error) => {
          console.error('Error:', error);
        },
      });
      pluggyConnect.init();
    },
    async updateBankAccount(itemId) {
      const response = await BankAccountService.updatePluggyId(this.selectedAccount.id, itemId);
      if (response.success) {
        this.$emit("input", { id: this.selectedAccount.id, content: this.selectedAccount.content });
        this.hideVodal("connectOpenFinanceAccount");
      }
    },
  },
};
</script>
<style scoped></style>
